'use client'

import type { TopNavV6Props } from '@src/components/TopNavV6/TopNavV6Props'

import { TopNavV6MobileBar } from './TopNavV6MobileBar'
import { TopNavV6MobileSlidingPanel } from './TopNavV6MobileSlidingPanel'

export const TopNavV6Mobile = (props: TopNavV6Props) => {
  return (
    <nav className="relative z-50 overflow-x-clip lg:hidden">
      <div className="w-full bg-bodi-black-text font-medium text-bodi-white">
        <TopNavV6MobileBar {...props} />
      </div>
      <TopNavV6MobileSlidingPanel {...props} />
    </nav>
  )
}
